import * as yup from "yup";

const formGuestValidationSchema = yup.object().shape({
    name: yup
        .string()
        .max(50, 'Al massimo ${max} caratteri') // eslint-disable-line
        .required('Campo obbligatorio'),
    surname: yup
        .string()
        .max(50, 'Al massimo ${max} caratteri') // eslint-disable-line
        .required('Campo obbligatorio'),
    sex: yup
        .string()
        .oneOf(['M', 'F'])
        .typeError('Campo non valido')
        .required('Campo obbligatorio'),
    nationality: yup
        .object()
        .typeError('Campo non valido')
        .required('Campo obbligatorio'),
    countryOfResidence: yup
        .mixed()
        .when('nationality', {
            is: (nationality) => nationality?.code === "IT",
            then: yup.object()
                .typeError('Campo non valido')
                .required('Campo obbligatorio'),
        }),
    placeOfResidence: yup
        .mixed()
        .when(['nationality', 'countryOfResidence'], {
            is: (nationality, countryOfResidence) => nationality?.code === "IT" && countryOfResidence?.code === "IT",
            then: yup.object()
                .typeError('Campo non valido')
                .required('Campo obbligatorio'),
        }),
    dateOfBirth: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .min('1900', "Data non valida, deve essere maggiore di 01/01/1900")
        .max(new Date(), "Data non valida, deve essere minore rispetto ad oggi")
        .required('Campo obbligatorio'),
    countryOfBirth: yup
        .object()
        .typeError('Campo non valido')
        .required('Campo obbligatorio'),
    placeOfBirth: yup
        .mixed()
        .when('countryOfBirth', {
            is: (countryOfBirth) => countryOfBirth?.code === "IT",
            then: yup.object()
                .typeError('Campo non valido')
                .required('Campo obbligatorio'),
        }),
});

export default formGuestValidationSchema